<template>
  <div>
    <div class="personal-center" v-for="(item, key) in newArr" :key="key">
        <router-link class="flex-item" v-for="(items, keys) in item.arrItem" :key="keys" :style="{backgroundImage:'url('+items.icon+')'}" :to="items.link">
            <div @click="isShow(items.title)">
              <span>{{items.title}}</span><br>
              <small>{{items.subTit}}</small>
            </div>
        </router-link>
    </div>

    <bMobileShowPhone v-if="showModal" @close="showModal = false">
      <div slot="header" @click="getPhoneAndEmailFn('phone', '852 2655 0338')">电话： 400 - 8428 - 393</div>
      <div slot="body" @click="getPhoneAndEmailFn('email', 'cs@eddidsec.com')">邮箱：cs@eddidsec.com</div>
    </bMobileShowPhone>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      allDatas: [
        { icon: require('@/assets/images/personalCenter/hy_ico_zh.png'), title: '账户信息', subTit: '个人账户信息', link: '/account-info' },
        { icon: require('@/assets/images/personalCenter/hy_ico_jy.png'), title: '交易账户申请', subTit: '申请其他交易账户', link: '/other-account' },
        { icon: require('@/assets/images/personalCenter/hy_ico_jg.png'), title: '结构性产品申请', subTit: '申请交易结构性产品', link: '/trade-product' },
        { icon: require('@/assets/images/personalCenter/hy_ico_zzh.png'), title: '子账户申请', subTit: '方便客户存取款', link: '/sub-account' },
        { icon: require('@/assets/images/personalCenter/hy_ico_zi.png'), title: '资金记录', subTit: '存取款及转账的记录', link: '/records' },
        { icon: require('@/assets/images/personalCenter/hy_ico_zz.png'), title: '内部转账', subTit: '交易账户之间的转账', link: '/fund-transfer' },
        { icon: require('@/assets/images/personalCenter/hy_ico_qk.png'), title: '取款', subTit: '取出资金', link: '/withdrawal' },
        { icon: require('@/assets/images/personalCenter/hy_ico_ck.png'), title: '存款', subTit: '存入资金', link: '/deposit' },
        { icon: require('@/assets/images/personalCenter/hy_ico_xz.png'), title: '文件下载', subTit: '常用表格与资料', link: '/table-download' },
        { icon: require('@/assets/images/personalCenter/hy_ico_pt.png'), title: '平台下载', subTit: '下载交易平台', link: '/download' },
        { icon: require('@/assets/images/personalCenter/hy_ico_pt copy.png'), title: '账户设置', subTit: '设置账户信息', link: '/setting' },
        { icon: require('@/assets/images/personalCenter/hy_ico_kf.png'), title: '联系客服', subTit: '需要帮助可联系客服', link: '' }
      ],
      newArr: [],
      showModal: false
    }
  },
  computed: {
    ...mapGetters(['getClientProfile']),
    countryIssue () {
      return this.getClientProfile.userInfo.countryIssue
    }
  },
  mounted () {
    console.log('        ************ this.countryIssue ', this.countryIssue)
    let tempArr = []
    if (this.countryIssue === 'CHN') {
      tempArr = this.allDatas
    } else {
      tempArr = this.allDatas
      tempArr.splice(3, 1)
    }
    for (var i = 0; i < tempArr.length; i++) {
      var arrItem = [
        { icon: null, title: null, subTit: null, link: null },
        { icon: null, title: null, subTit: null, link: null }
      ]
      if (i % 2 === 0) {
        if ((i + 1) === tempArr.length) {
          arrItem[0] = tempArr[i]
          arrItem[1].icon = null
          arrItem[1].title = null
          arrItem[1].subTit = null
          arrItem[1].link = ''
        } else {
          arrItem[0] = tempArr[i]
          arrItem[1] = tempArr[i + 1]
        }
        this.newArr.push({ arrItem })
      }
    }
  },
  methods: {
    getPhoneAndEmailFn (key, val) {
      var obj = {}
      obj[key] = val
      const stringifyObj = JSON.stringify(obj)
      const { WebViewBridge } = window
      if (WebViewBridge) {
        WebViewBridge.send(stringifyObj)
      }
    },
    isShow (val) {
      this.showModal = (val === '联系客服')
    }
  }
}
</script>
<style lang="scss">
  .personal-center {
    visibility: hidden;
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-bottom: 2px;
    background: #e8e8ee;
      .flex-item {
        flex: 1;
        word-wrap:break-word;
        padding:20px 20px 20px 46px;
        background-color:#fff;
        background-repeat: no-repeat;
        background-position: 10px center;
        background-size: 26px 26px;
        font-size: 14px;
        margin-right: 1px;
        text-decoration: none;
        span{
            color:#000;
        }
        small{
            color:#a0a0a0;
        }
      }
    }
    @media (max-width: 768px){
      .layout-container .container .view {
          max-width: 100%;
          padding: 0;
          margin: 0;
      }
      .personal-center {
        visibility: visible;
      }
    }
</style>
